import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Constants } from '../../adapters/helpers/Constants';
import BreadCrumbSEO from '../SEOSchema/BreadCrumbSEO';
import { getBreadcrumbsBySlug } from '../../adapters/helpers/getBreadcrumbsBySlug';
const BreadCrumbs = props => {
  var _props$extraAttribute;
  const [hasBreadcrumb, setHasBreadcrumb] = useState(false);
  const [breadCrumbValue, setBreadCrumbValue] = useState([]);
  const breadCrumbData = props == null ? void 0 : (_props$extraAttribute = props.extraAttributes) == null ? void 0 : _props$extraAttribute.breadCrumbData;
  useEffect(() => {
    var _window, _window$location;
    let pathName = (_window = window) == null ? void 0 : (_window$location = _window.location) == null ? void 0 : _window$location.pathname;
    async function fetchData() {
      const breadCrumbsValue = await getBreadcrumbsBySlug(pathName);
      if (breadCrumbsValue && breadCrumbsValue.length > 1) {
        setHasBreadcrumb(true);
        setBreadCrumbValue(breadCrumbsValue);
      }
    }
    fetchData();
    const productSubNavEle = document.getElementById('ob-product-subnav-scroll');
    const headerEle = document.getElementsByClassName('zone-header');
    if (!productSubNavEle && (headerEle == null ? void 0 : headerEle[0])) {
      headerEle[0].style.position = 'fixed';
    }
  }, []);
  return <React.Fragment>
            {breadCrumbData && (breadCrumbData == null ? void 0 : breadCrumbData.length) > 0 ? <React.Fragment>
                  <BreadCrumbSEO breadcrumb={breadCrumbData} />
                    <nav className='breadcrumb-main' aria-label={Constants.breadCrumpLabel} id='breadcrumb-main'>
                        <ul className='breadcrumb' itemScope aria-label='Breadcrumbs'>
                            {breadCrumbData && breadCrumbData.map((val, key) => {
            var _val$fields, _val$fields2, _val$fields2$title;
            return <li key={key}>
                                            {val.fields.link ? <a aria-label={`${val == null ? void 0 : (_val$fields = val.fields) == null ? void 0 : _val$fields.title}`} className='event_internal_link' href={val.fields.link} data-action-detail={val.fields.link}>
                                                    {val.fields.title.toUpperCase()}
                                                </a> : <span className='activeMenu'>{val == null ? void 0 : (_val$fields2 = val.fields) == null ? void 0 : (_val$fields2$title = _val$fields2.title) == null ? void 0 : _val$fields2$title.toUpperCase()}</span>}
                                        </li>;
          })}
                        </ul>
                    </nav>
                </React.Fragment> : hasBreadcrumb && breadCrumbValue ? <React.Fragment>
                <nav className="breadcrumb-main" aria-label={Constants.breadCrumpLabel} id="breadcrumb-main">
              <ul className="breadcrumb" itemScope aria-label="Breadcrumbs">
                {breadCrumbValue && breadCrumbValue.map((val, key) => {
            return <li key={key}>
                        {val.linkUrl ? <a aria-label={`${Constants.breadCrumpLabel}-${val.pageTitle}`} href={val.linkUrl}>{val.pageTitle}</a> : <span className="activeMenu">{val.pageTitle}</span>}
                      </li>;
          })}
              </ul>
            </nav>
            <BreadCrumbSEO breadcrumb={breadCrumbValue} />
            </React.Fragment> : <React.Fragment>
                    <nav className='breadcrumb-main' aria-label={Constants.breadCrumpLabel} id='breadcrumb-main'>
                        <ul className='breadcrumb' itemScope aria-label='Breadcrumbs'>
                            <li>
                                <span className='op-breadcrumb-loading'>{Constants.Loading}</span>
                            </li>
                        </ul>
                    </nav>
                </React.Fragment>}
        </React.Fragment>;
};
BreadCrumbs.propTypes = {
  breadcrumbs: PropTypes.array
};
export default BreadCrumbs;